<div class="blade-wrapper">
  <div class="blade-header">
    <div *ngIf="initialized && $hasDataLoaded && !$hasMissingRequiredInParams" class="blade-tools">
      <div data-cy="tool-id-submit" *ngIf="!toolbar.submit.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.submit.control.readOnly"
              [ngStyle]="toolbar.submit.control.styles.style"
              [ngClass]="toolbar.submit.control.styles.classes"
              (click)="on_submit_order($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.submit.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.submit.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.submit.control.label}}</div>
        </div>
      
      </button>
      </div>
      <div data-cy="tool-id-appointment" *ngIf="!toolbar.appointment.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.appointment.control.readOnly"
              [ngStyle]="toolbar.appointment.control.styles.style"
              [ngClass]="toolbar.appointment.control.styles.classes"
              (click)="on_appointment_clicked($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.appointment.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.appointment.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.appointment.control.label}}</div>
        </div>
      
      </button>
      </div>
      <div data-cy="tool-id-separator1" *ngIf="!toolbar.separator1.hidden" class="toolContainer">
      <div class="tool-separator"></div>
      </div>
      <div data-cy="tool-id-cancel" *ngIf="!toolbar.cancel.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.cancel.control.readOnly"
              [ngStyle]="toolbar.cancel.control.styles.style"
              [ngClass]="toolbar.cancel.control.styles.classes"
              (click)="on_cancel_clicked($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.cancel.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.cancel.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.cancel.control.label}}</div>
        </div>
      
      </button>
      </div>
      <div data-cy="tool-id-on_delete" *ngIf="!toolbar.on_delete.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.on_delete.control.readOnly"
              [ngStyle]="toolbar.on_delete.control.styles.style"
              [ngClass]="toolbar.on_delete.control.styles.classes"
              (click)="on_delete_clicked($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.on_delete.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.on_delete.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.on_delete.control.label}}</div>
        </div>
      
      </button>
      </div>
      <div data-cy="tool-id-separator2" *ngIf="!toolbar.separator2.hidden" class="toolContainer">
      <div class="tool-separator"></div>
      </div>
      <div data-cy="tool-id-attachments" *ngIf="!toolbar.attachments.hidden" class="toolContainer">
      <button mat-button
              data-cy="button"
              class="datex-button"
              [disabled]="toolbar.attachments.control.readOnly"
              [ngStyle]="toolbar.attachments.control.styles.style"
              [ngClass]="toolbar.attachments.control.styles.classes"
              (click)="on_attachments_clicked($event)"
              >
        <div class="button-label">
          <ng-container *ngIf="toolbar.attachments.control.icon === 'datex-default-spinner'; else showIcon">
            <div class="button-icon">
              <i data-cy="button-icon" class="datex-default-spinner"></i>
            </div>
          </ng-container>
          <ng-template #showIcon>
            <div class="button-icon">
              <i data-cy="button-icon" class="icon {{toolbar.attachments.control.icon}}"></i>
            </div>
          </ng-template>
          <div data-cy="button-label" class="button-text">{{toolbar.attachments.control.label}}</div>
        </div>
      
      </button>
      </div>
      <div data-cy="tool-id-on_print" *ngIf="!toolbar.on_print.hidden" class="toolContainer">
      <button mat-button 
              data-cy="splitbutton"
              class="datex-button splitbutton" 
              [disabled]="toolbar.on_print.control.readOnly"
              [ngStyle]="toolbar.on_print.control.styles.style"
              [ngClass]="toolbar.on_print.control.styles.classes"
              [matMenuTriggerFor]="dropdownMenuOne">
        <div class="button-label">
          <div *ngIf="toolbar.on_print.control.icon"
                class="button-icon">
            <i data-cy="splitbutton-icon" class="icon {{toolbar.on_print.control.icon}}"></i>
          </div>
          <div data-cy="splitbutton-label" class="button-text">{{toolbar.on_print.control.label}}</div>
          <div class="button-icon splitbutton-drop-icon">
            <i data-cy="splitbutton-icon" class="icon icon-ic_fluent_chevron_down_20_regular"></i>
          </div>
        </div>
      </button>
      <mat-menu #dropdownMenuOne="matMenu" class="options-menu splitbutton-menu">
        <div data-cy="splitbutton-options">
          <div mat-menu-item class="splitbutton-item-container">
            <button mat-button
                    data-cy="splitbutton-sub-item"
                    class="datex-button splitbutton-sub-item" 
                    [disabled]="toolbar.on_print.control.buttons.receiving_report.readOnly"
                    [ngStyle]="toolbar.on_print.control.buttons.receiving_report.styles.style"
                    [ngClass]="toolbar.on_print.control.buttons.receiving_report.styles.classes"
                    (click)="on_receiving_report_clicked($event)">
              <div class="button-label">
                <div *ngIf="toolbar.on_print.control.buttons.receiving_report.icon"
                    class="button-icon">
                  <i data-cy="splitbutton-sub-item-icon" class="icon {{toolbar.on_print.control.buttons.receiving_report.icon}}"></i>
                </div>
                <div data-cy="splitbutton-sub-item-label"
                    class="button-text">{{toolbar.on_print.control.buttons.receiving_report.label}}</div>
              </div>
            </button>
          </div>
          <div mat-menu-item class="splitbutton-item-container">
            <button mat-button
                    data-cy="splitbutton-sub-item"
                    class="datex-button splitbutton-sub-item" 
                    [disabled]="toolbar.on_print.control.buttons.unloading_tally_report.readOnly"
                    [ngStyle]="toolbar.on_print.control.buttons.unloading_tally_report.styles.style"
                    [ngClass]="toolbar.on_print.control.buttons.unloading_tally_report.styles.classes"
                    (click)="on_unloading_tally_clicked($event)">
              <div class="button-label">
                <div *ngIf="toolbar.on_print.control.buttons.unloading_tally_report.icon"
                    class="button-icon">
                  <i data-cy="splitbutton-sub-item-icon" class="icon {{toolbar.on_print.control.buttons.unloading_tally_report.icon}}"></i>
                </div>
                <div data-cy="splitbutton-sub-item-label"
                    class="button-text">{{toolbar.on_print.control.buttons.unloading_tally_report.label}}</div>
              </div>
            </button>
          </div>
        </div>
      </mat-menu>
      </div>
      <div data-cy="tool-id-separator3" *ngIf="!toolbar.separator3.hidden" class="toolContainer">
      <div class="tool-separator"></div>
      </div>
      <div data-cy="tool-id-options" *ngIf="!toolbar.options.hidden" class="toolContainer">
      <button mat-button 
              data-cy="splitbutton"
              class="datex-button splitbutton" 
              [disabled]="toolbar.options.control.readOnly"
              [ngStyle]="toolbar.options.control.styles.style"
              [ngClass]="toolbar.options.control.styles.classes"
              [matMenuTriggerFor]="dropdownMenuOne">
        <div class="button-label">
          <div *ngIf="toolbar.options.control.icon"
                class="button-icon">
            <i data-cy="splitbutton-icon" class="icon {{toolbar.options.control.icon}}"></i>
          </div>
          <div data-cy="splitbutton-label" class="button-text">{{toolbar.options.control.label}}</div>
          <div class="button-icon splitbutton-drop-icon">
            <i data-cy="splitbutton-icon" class="icon icon-ic_fluent_chevron_down_20_regular"></i>
          </div>
        </div>
      </button>
      <mat-menu #dropdownMenuOne="matMenu" class="options-menu splitbutton-menu">
        <div data-cy="splitbutton-options">
          <div mat-menu-item class="splitbutton-item-container">
            <button mat-button
                    data-cy="splitbutton-sub-item"
                    class="datex-button splitbutton-sub-item" 
                    [disabled]="toolbar.options.control.buttons.email_requests.readOnly"
                    [ngStyle]="toolbar.options.control.buttons.email_requests.styles.style"
                    [ngClass]="toolbar.options.control.buttons.email_requests.styles.classes"
                    (click)="on_email_requests_clicked($event)">
              <div class="button-label">
                <div *ngIf="toolbar.options.control.buttons.email_requests.icon"
                    class="button-icon">
                  <i data-cy="splitbutton-sub-item-icon" class="icon {{toolbar.options.control.buttons.email_requests.icon}}"></i>
                </div>
                <div data-cy="splitbutton-sub-item-label"
                    class="button-text">{{toolbar.options.control.buttons.email_requests.label}}</div>
              </div>
            </button>
          </div>
          <div mat-menu-item class="splitbutton-item-container">
            <button mat-button
                    data-cy="splitbutton-sub-item"
                    class="datex-button splitbutton-sub-item" 
                    [disabled]="toolbar.options.control.buttons.discussions.readOnly"
                    [ngStyle]="toolbar.options.control.buttons.discussions.styles.style"
                    [ngClass]="toolbar.options.control.buttons.discussions.styles.classes"
                    (click)="on_discussions_clicked($event)">
              <div class="button-label">
                <div *ngIf="toolbar.options.control.buttons.discussions.icon"
                    class="button-icon">
                  <i data-cy="splitbutton-sub-item-icon" class="icon {{toolbar.options.control.buttons.discussions.icon}}"></i>
                </div>
                <div data-cy="splitbutton-sub-item-label"
                    class="button-text">{{toolbar.options.control.buttons.discussions.label}}</div>
              </div>
            </button>
          </div>
        </div>
      </mat-menu>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-editor">
      <ng-container *ngIf="initialized && $hasDataLoaded && !$hasMissingRequiredInParams">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text"></span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-order_header" *ngIf="!fields.order_header.hidden" 
                            class="field-container double {{fields.order_header.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.order_header.styles.style"
                            [ngClass]="fields.order_header.styles.classes">
                        <div class="label-container"
                              title="{{fields.order_header.label}}{{fields.order_header.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.order_header.label}}">{{fields.order_header.label}}<span *ngIf="fields.order_header.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <div data-cy="text" class="datex-text"
                              [ngStyle]="fields.order_header.control.styles.style"
                              [ngClass]="fields.order_header.control.styles.classes">{{fields.order_header.control.text }}</div>
                        <ng-container *ngIf="fields.order_header.invalid">
                          <ng-container *ngFor="let error of fields.order_header.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-order_state" *ngIf="!fields.order_state.hidden" 
                            class="field-container double {{fields.order_state.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.order_state.styles.style"
                            [ngClass]="fields.order_state.styles.classes">
                        <div class="label-container"
                              title="{{fields.order_state.label}}{{fields.order_state.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.order_state.label}}">{{fields.order_state.label}}<span *ngIf="fields.order_state.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <div data-cy="text" class="datex-text"
                              [ngStyle]="fields.order_state.control.styles.style"
                              [ngClass]="fields.order_state.control.styles.classes">{{fields.order_state.control.text }}</div>
                        <ng-container *ngIf="fields.order_state.invalid">
                          <ng-container *ngFor="let error of fields.order_state.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-newGroup2"
                     *ngIf="!fieldsets.newGroup2.hidden"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup2.collapsible }">
                    <div *ngIf="!fieldsets.newGroup2.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup2.toggle()">
                      <span class="fieldsetsTitle-text">Details</span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup2.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup2.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup2.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup2.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-reference" *ngIf="!fields.reference.hidden" 
                            class="field-container standard {{fields.reference.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.reference.styles.style"
                            [ngClass]="fields.reference.styles.classes">
                        <div class="label-container"
                              title="{{fields.reference.label}}{{fields.reference.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.reference.label}}">{{fields.reference.label}}<span *ngIf="fields.reference.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <input data-cy="textBox"formControlName="reference"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{fields.reference.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.reference.control.placeholder}}"
                                [ngStyle]="fields.reference.control.styles.style"
                                [ngClass]="fields.reference.control.styles.classes"> 
                        <ng-container *ngIf="fields.reference.invalid">
                          <ng-container *ngFor="let error of fields.reference.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-vendor_reference" *ngIf="!fields.vendor_reference.hidden" 
                            class="field-container standard {{fields.vendor_reference.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.vendor_reference.styles.style"
                            [ngClass]="fields.vendor_reference.styles.classes">
                        <div class="label-container"
                              title="{{fields.vendor_reference.label}}{{fields.vendor_reference.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.vendor_reference.label}}">{{fields.vendor_reference.label}}<span *ngIf="fields.vendor_reference.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <input data-cy="textBox"formControlName="vendor_reference"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{fields.vendor_reference.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.vendor_reference.control.placeholder}}"
                                [ngStyle]="fields.vendor_reference.control.styles.style"
                                [ngClass]="fields.vendor_reference.control.styles.classes"> 
                        <ng-container *ngIf="fields.vendor_reference.invalid">
                          <ng-container *ngFor="let error of fields.vendor_reference.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-expected_date" *ngIf="!fields.expected_date.hidden" 
                            class="field-container standard {{fields.expected_date.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.expected_date.styles.style"
                            [ngClass]="fields.expected_date.styles.classes">
                        <div class="label-container"
                              title="{{fields.expected_date.label}}{{fields.expected_date.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.expected_date.label}}">{{fields.expected_date.label}}<span *ngIf="fields.expected_date.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <app-datebox 
                            data-cy="dateBox"
                            formControlName="expected_date"
                            [format]="fields.expected_date.control.format"
                            [mode]="fields.expected_date.control.mode"
                            [ngStyle]="fields.expected_date.control.styles.style"
                            [ngClass]="fields.expected_date.control.styles.classes">
                        </app-datebox>
                        <ng-container *ngIf="fields.expected_date.invalid">
                          <ng-container *ngFor="let error of fields.expected_date.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-carrier" *ngIf="!fields.carrier.hidden" 
                            class="field-container standard {{fields.carrier.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.carrier.styles.style"
                            [ngClass]="fields.carrier.styles.classes">
                        <div class="label-container"
                              title="{{fields.carrier.label}}{{fields.carrier.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.carrier.label}}">{{fields.carrier.label}}<span *ngIf="fields.carrier.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <Carriers-carriers_ownerscarriers_dd_single 
                            data-cy="selector"
                            [type]="fields.carrier.control.type"
                            formControlName="carrier"
                            (displayTextChange)="fields.carrier.control.displayText=$event"
                            [placeholder]="fields.carrier.control.placeholder"
                            [styles]="fields.carrier.control.styles"
                          [ownerId]="$fields_carrier_selector_inParams_ownerId"
                        >
                        </Carriers-carriers_ownerscarriers_dd_single>
                        <ng-container *ngIf="fields.carrier.invalid">
                          <ng-container *ngFor="let error of fields.carrier.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-trailer_number" *ngIf="!fields.trailer_number.hidden" 
                            class="field-container standard {{fields.trailer_number.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.trailer_number.styles.style"
                            [ngClass]="fields.trailer_number.styles.classes">
                        <div class="label-container"
                              title="{{fields.trailer_number.label}}{{fields.trailer_number.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.trailer_number.label}}">{{fields.trailer_number.label}}<span *ngIf="fields.trailer_number.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <input data-cy="textBox"formControlName="trailer_number"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{fields.trailer_number.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.trailer_number.control.placeholder}}"
                                [ngStyle]="fields.trailer_number.control.styles.style"
                                [ngClass]="fields.trailer_number.control.styles.classes"> 
                        <ng-container *ngIf="fields.trailer_number.invalid">
                          <ng-container *ngFor="let error of fields.trailer_number.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-seal_number" *ngIf="!fields.seal_number.hidden" 
                            class="field-container standard {{fields.seal_number.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.seal_number.styles.style"
                            [ngClass]="fields.seal_number.styles.classes">
                        <div class="label-container"
                              title="{{fields.seal_number.label}}{{fields.seal_number.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.seal_number.label}}">{{fields.seal_number.label}}<span *ngIf="fields.seal_number.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <input data-cy="textBox"formControlName="seal_number"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{fields.seal_number.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.seal_number.control.placeholder}}"
                                [ngStyle]="fields.seal_number.control.styles.style"
                                [ngClass]="fields.seal_number.control.styles.classes"> 
                        <ng-container *ngIf="fields.seal_number.invalid">
                          <ng-container *ngFor="let error of fields.seal_number.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-notes" *ngIf="!fields.notes.hidden" 
                            class="field-container double {{fields.notes.invalid ? 'invalid' : ''}}"
                            [ngStyle]="fields.notes.styles.style"
                            [ngClass]="fields.notes.styles.classes">
                        <div class="label-container"
                              title="{{fields.notes.label}}{{fields.notes.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{fields.notes.label}}">{{fields.notes.label}}<span *ngIf="fields.notes.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <input data-cy="textBox"formControlName="notes"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{fields.notes.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{fields.notes.control.placeholder}}"
                                [ngStyle]="fields.notes.control.styles.style"
                                [ngClass]="fields.notes.control.styles.classes"> 
                        <ng-container *ngIf="fields.notes.invalid">
                          <ng-container *ngFor="let error of fields.notes.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
                  </div>
                </div>
              </div>
        <div class="widgets">
          <div *ngIf="!widgets.orderline_total_amount_widget.hidden" class="widget-container">
            <PurchaseOrders-orderline_total_amount_widget
            #$widgets_orderline_total_amount_widget 
              [orderId]="$widgets_orderline_total_amount_widget_inParams_orderId"
            ($refreshEvent)="refresh(false, false, '$widgets_orderline_total_amount_widget')"
            >
            </PurchaseOrders-orderline_total_amount_widget>
          </div>
          <div *ngIf="!widgets.orderline_total_received_widget.hidden" class="widget-container">
            <PurchaseOrders-orderline_total_received_widget
            #$widgets_orderline_total_received_widget 
              [orderId]="$widgets_orderline_total_received_widget_inParams_orderId"
            ($refreshEvent)="refresh(false, false, '$widgets_orderline_total_received_widget')"
            >
            </PurchaseOrders-orderline_total_received_widget>
          </div>
          <div *ngIf="!widgets.orderline_total_gross_received_widget.hidden" class="widget-container">
            <PurchaseOrders-orderline_total_gross_received_widget
            #$widgets_orderline_total_gross_received_widget 
              [orderId]="$widgets_orderline_total_gross_received_widget_inParams_orderId"
            ($refreshEvent)="refresh(false, false, '$widgets_orderline_total_gross_received_widget')"
            >
            </PurchaseOrders-orderline_total_gross_received_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="!tabs.purchase_order_lines.hidden" class="tab" data-cy="tab-purchase_order_lines">
              <h2 [className]="tabs.purchase_order_lines.active? 'active': ''" (click)="tabs.purchase_order_lines.activate()">{{tabs.purchase_order_lines.title}}</h2>
            </div>
            <div *ngIf="!tabs.contacts.hidden" class="tab" data-cy="tab-contacts">
              <h2 [className]="tabs.contacts.active? 'active': ''" (click)="tabs.contacts.activate()">{{tabs.contacts.title}}</h2>
            </div>
            <div *ngIf="!tabs.received_inventory.hidden" class="tab" data-cy="tab-received_inventory">
              <h2 [className]="tabs.received_inventory.active? 'active': ''" (click)="tabs.received_inventory.activate()">{{tabs.received_inventory.title}}</h2>
            </div>
            <div *ngIf="!tabs.tasks.hidden" class="tab" data-cy="tab-tasks">
              <h2 [className]="tabs.tasks.active? 'active': ''" (click)="tabs.tasks.activate()">{{tabs.tasks.title}}</h2>
            </div>
          </div>
        
              <FootPrintPortalManager-receiving_order_lines_grid *ngIf="tabs.purchase_order_lines.active"
              #$tabs_purchase_order_lines
              [orderId]="$tabs_purchase_order_lines_receiving_order_lines_grid_inParams_orderId"
              [shipmentId]="$tabs_purchase_order_lines_receiving_order_lines_grid_inParams_shipmentId"
              [projectId]="$tabs_purchase_order_lines_receiving_order_lines_grid_inParams_projectId"
              [orderStatusId]="$tabs_purchase_order_lines_receiving_order_lines_grid_inParams_orderStatusId"
              ($refreshEvent)="refresh(false, false, '$tabs_purchase_order_lines')">
              </FootPrintPortalManager-receiving_order_lines_grid>
              <FootPrintPortalManager-orderaddresses_grid *ngIf="tabs.contacts.active"
              #$tabs_contacts
              [orderId]="$tabs_contacts_orderaddresses_grid_inParams_orderId"
              ($refreshEvent)="refresh(false, false, '$tabs_contacts')">
              </FootPrintPortalManager-orderaddresses_grid>
              <FootPrintPortalManager-receiving_order_received_inventory_grid *ngIf="tabs.received_inventory.active"
              #$tabs_received_inventory
              [orderId]="$tabs_received_inventory_receiving_order_received_inventory_grid_inParams_orderId"
              [shipmentId]="$tabs_received_inventory_receiving_order_received_inventory_grid_inParams_shipmentId"
              ($refreshEvent)="refresh(false, false, '$tabs_received_inventory')">
              </FootPrintPortalManager-receiving_order_received_inventory_grid>
              <FootPrintPortalManager-receiving_order_tasks_grid *ngIf="tabs.tasks.active"
              #$tabs_tasks
              [orderId]="$tabs_tasks_receiving_order_tasks_grid_inParams_orderId"
              [shipmentId]="$tabs_tasks_receiving_order_tasks_grid_inParams_shipmentId"
              ($refreshEvent)="refresh(false, false, '$tabs_tasks')">
              </FootPrintPortalManager-receiving_order_tasks_grid>
        </div>
      </ng-container>

      <div *ngIf="$hasMissingRequiredInParams" class="missing-params">
        <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
      </div>
      <div *ngIf="initialized && !$hasDataLoaded && !$hasMissingRequiredInParams" class="missing-params">
        <h3>No data to display</h3>
      </div>
    </div>
  </div>
</div>